import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { Typography } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    padding: '6px 10px',
    borderRadius: 25,
    backgroundColor: '#c2e1fb',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    margin: 5,
    height: 'fit-content'
  }
}));

const ListButton = ({ children, icon, onClick }) => {
  const classes = useStyles();

  return (
    <div style={{ display: 'flex' }}>
      <div className={classes.buttonContainer} onClick={onClick}>
        <FontAwesomeIcon
          icon={icon}
          size='sm'
          color='#0073d1'
          style={{ marginRight: 5 }}
        />
        <Typography variant='body1' color={'#0073d1'}>
          {children}
        </Typography>
      </div>
    </div>
  );
};

ListButton.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func
};

export default ListButton;
